import React, { useState, useEffect, Fragment } from "react";
import { useLocation, useHistory } from "react-router";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import VideoUpload from "../../components/ContentUpload/VideoUpload";
import MediaSelect from "../../components/MediaSelect";
import Icon from "./Icon";
import { TerritoryOptions } from "../../Constants/retailer";
import { UPLOADING_VIDEO } from "../../Constants/string";
import "./index.css";

const smile_whiteIcon = require("../../assets/media/landing/white/smile_white.png");
const shopping_whiteIcon = require("../../assets/media/landing/white/shopping_white.png");
const star_whiteIcon = require("../../assets/media/landing/white/star_white.png");
const chip_whiteIcon = require("../../assets/media/landing/white/chip_white.png");
const video_whiteIcon = require("../../assets/media/landing/white/video_white.png");
const smile_blackIcon = require("../../assets/media/landing/black/smile_black.png");
const shopping_blackIcon = require("../../assets/media/landing/black/shopping_black.png");
const star_blackIcon = require("../../assets/media/landing/black/star_black.png");
const chip_blackIcon = require("../../assets/media/landing/black/chip_black.png");
const video_blackIcon = require("../../assets/media/landing/black/video_black.png");

const MembersWelcomeMessage = () => {
  const location = useLocation();
  const history = useHistory();
  const [welcome_messages, setWelcomeMessages] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [changed, setChanged] = useState(false);
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(true);
  const [loading_script, setLoadingScript] = useState("");
  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        setLoading(false);
        if (brand_data) {
          setBrandData(brand_data);
          setWelcomeMessages(
            brand_data.welcome_messages || getStandardMessage(brand_data.name)
          );
          setMediaType(brand_data.welcome_media_type || "");
          setMediaUrl(brand_data.welcome_media_url || "");
        }
      });
    }
  }, [location]);

  const getStandardMessage = (brand_name) => {
    return [
      "Earn tokens for being a community hero, responding to polls, giving your feedback to forum posts and inviting friends to join you.",
      "Spend your tokens on shopping through TokenPay with 60 premier retailers, redeeming on average 10 tokens for every £1 spent.",
      `Spend your tokens in the ${brand_name} marketplace to save money and time, with ${brand_name} products and subscriptions helping you live your best life.`,
      "Your ecosystem makes it easier for you to live your best life through community solidarity, saving time and saving money.",
    ];
  };
  const handleChangeInput = ({ target }) => {
    const newWelcomeMessages = [...welcome_messages];
    newWelcomeMessages[target.name] = target.value;
    setWelcomeMessages(newWelcomeMessages);
    setChanged(true);
  };
  const saveWelcomeMessage = () => {
    Firebase.updateBrandDataById(brand, {
      welcome_messages, welcome_media_type: mediaType,
      welcome_media_url: mediaUrl
    }).then((res) => {
      setChanged(false);
    });
  };

  const handleSetMedia = (type, url) => {
    setMediaType(type);
    setMediaUrl(url);
    if ((brand_data.welcome_media_type && brand_data.welcome_media_type !== type) || (brand_data.welcome_media_url && brand_data.welcome_media_url !== url)) {
      setChanged(true);
    }
    if ((!brand_data.welcome_media_type && type !== "") || (!brand_data.welcome_media_url && url !== "")) {
      setChanged(true);
    }
    // if (brand) {
    //   Firebase.updateBrandDataById(brand, {
    //     welcome_media_type: type,
    //     welcome_media_url: url,
    //   });
    // }
  };

  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingScript(loading_script);
  };

  const handleUploadError = (error) => {
    setLoadingScript("");
    setLoading(false);
  };

  // const uploadContent = async (mediaContent) => {
  //   const uploadFolder = "welcome_messages/" + brand_data.name;
  //   const title = new Date().getTime().toString();
  //   const uploadTask = Firebase.uploadVideo(
  //     mediaContent,
  //     uploadFolder + "/videos"
  //   );
  //   setLoading(true);
  //   setLoadingScript(UPLOADING_VIDEO);
  //   uploadTask.on(
  //     "state_changed",
  //     handleUploadProgress,
  //     handleUploadError,
  //     () => {
  //       uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
  //         setLoading(false);
  //         setLoadingScript("");
  //         handleSetMediaURL(downloadURL);
  //       });
  //     }
  //   );
  // };
  return (
    <div id="main-container">
      {loading && (
        <div className="loading_container">
          <div className="loading">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
          <p style={{ textAlign: "center", marginTop: 5 }}>{loading_script}</p>
        </div>
      )}
      <div className="welcome-chatbot-group">
        <div className="chatbot-inputs">
          <img
            alt=""
            src={brand_data.icon}
            width="50"
            style={{ borderRadius: 25 }}
          />
          <textarea
            rows="1"
            className="welcome-chatbot-input"
            disabled
            value={`Welcome to the ${brand_data.name} community ecosystem.`}
          ></textarea>
        </div>
        <div className="chatbot-inputs">
          <Icon
            icon={brand_data.white ? smile_whiteIcon : smile_blackIcon}
            background={brand_data.hex}
          />
          <textarea
            rows="1"
            className="welcome-chatbot-input"
            name="0"
            onChange={handleChangeInput}
            value={welcome_messages[0]}
          ></textarea>
        </div>
        <div className="chatbot-inputs">
          <Icon
            icon={brand_data.white ? chip_whiteIcon : chip_blackIcon}
            background={brand_data.hex}
          />
          <textarea
            rows="1"
            className="welcome-chatbot-input"
            name="1"
            onChange={handleChangeInput}
            value={welcome_messages[1]}
          ></textarea>
        </div>
        <div className="chatbot-inputs">
          <Icon
            icon={brand_data.white ? video_whiteIcon : video_blackIcon}
            background={brand_data.hex}
          />
          <div style={{ marginLeft: 10, width: 400 }}>
            <MediaSelect
              uploadFoler={`"welcome_messages/${brand_data.name}`}
              onChangeContent={handleSetMedia}
              existingContent={
                mediaType !== "" && mediaUrl !== ""
                  ? {
                    mediaType,
                    mediaUrl,
                  }
                  : undefined
              }
            />
            {/* <VideoUpload
                onChangeContent={uploadContent}
                defaultVideo={brand_data.welcome_video_url}
              /> */}
          </div>
        </div>
        <div className="chatbot-inputs">
          <Icon
            icon={brand_data.white ? shopping_whiteIcon : shopping_blackIcon}
            background={brand_data.hex}
          />
          <textarea
            rows="1"
            className="welcome-chatbot-input"
            name="2"
            onChange={handleChangeInput}
            value={welcome_messages[2]}
          ></textarea>
        </div>
        <div className="chatbot-inputs">
          <Icon
            icon={brand_data.white ? star_whiteIcon : star_blackIcon}
            background={brand_data.hex}
          />
          <textarea
            rows="1"
            className="welcome-chatbot-input"
            name="3"
            onChange={handleChangeInput}
            value={welcome_messages[3]}
          ></textarea>
        </div>
        {changed && (
          <button className="btn btn-save" onClick={saveWelcomeMessage}>
            Save
          </button>
        )}
      </div>
    </div>
  );
};
export default MembersWelcomeMessage;



// WEBPACK FOOTER //
// ./src/screens/WelcomeMessage/MemberWelcome.js